import {
  DEFAULT_PALETTE_ID,
  getColorPalette,
  type ColorPaletteId,
} from "@/lib/theme/color-palettes";
import type { PersonalizationSettings } from "@/lib/utils/personalization";
import { hexToRgba } from "@/lib/utils/color";

export function getAccentPrimaryFromPersonalization(
  personalization: PersonalizationSettings | null | undefined,
): string {
  const paletteId = personalization?.colorPalette ?? DEFAULT_PALETTE_ID;
  const customColor = personalization?.customColor ?? undefined;
  return getColorPalette(paletteId as ColorPaletteId, customColor).primary;
}

export function getBrandCssVariablesFromAccentPrimary(
  primary: string,
): Record<`--${string}`, string> {
  return {
    "--scrollbar-thumb": hexToRgba(primary, 0.3),
    "--scrollbar-thumb-hover": hexToRgba(primary, 0.5),
    "--selection-color": primary,
    "--selection-bg": hexToRgba(primary, 0.3),
  };
}

export function getBrandCssVariablesFromPersonalization(
  personalization: PersonalizationSettings | null | undefined,
): Record<`--${string}`, string> {
  return getBrandCssVariablesFromAccentPrimary(
    getAccentPrimaryFromPersonalization(personalization),
  );
}
